module.exports = __webpack_public_path__ + "img/alex_competencies.6c309c28.svg";